import { ErrorBoundary, Main } from "@goodfill/ui-components";
import { useRecoilState } from "recoil";
import { isGlobalStateLoadingState } from "../../state";
import { FallbackUI } from "../FallbackUI";

export const PageLayoutFull = ({ children }: { children: React.ReactNode }) => {
  const [isGlobalStateLoading] = useRecoilState(isGlobalStateLoadingState);

  return (
    <Main>
      {isGlobalStateLoading ? null : (
        <ErrorBoundary fallbackUI={<FallbackUI text="Error, could not render page" />}>{children}</ErrorBoundary>
      )}
    </Main>
  );
};
